import { CloseButton, HStack, Icon, Spacer, Text } from '@chakra-ui/react'

import { GuardTour } from '@/components/icons'

interface CreateTourPlanHeaderIProps {
  onClose: () => void
  edit?: boolean
}

export const CreateTourPlanHeader = ({
  onClose,
  edit,
}: CreateTourPlanHeaderIProps) => {
  return (
    <HStack align='center' direction='row' padding='24px' paddingX='16px'>
      <Icon as={GuardTour} boxSize='24px' strokeColor='#000' />
      <Text color='#1F2023' fontSize='24px' fontWeight={700} lineHeight='30px'>
        {edit ? 'Edit Tour Plan' : 'Create Tour Plan'}
      </Text>
      <Spacer />
      <CloseButton ml={4} onClick={onClose} />
    </HStack>
  )
}
